import React, { useEffect, useState } from 'react';
import Navbar from '../../Company/About/Navbar';
import WelcomeSection from './WelcomeSection';
import JobDetails from './JobDetails';
import TestActions from './TestActions';
import TestCard from './TestCard';
import UpcomingSchedule from './UpcomingSchedule';
import Footer from '../../Company/About/Footer';
import { cn } from '@/lib/utils';

export default function MockTest() {
  const [userName, setUserName] = useState(null); // State to store the user name
  const [loading, setLoading] = useState(true); // State to track if data is loading
  const [location, setLocation] = useState(null);
  const [experience, setExperience] = useState(null);
  const [tests, setTests] = useState([]);
  const [selectedTestType, setSelectedTestType] = useState("t"); // Default to "t" for Screening Test

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await fetch(`/api/get_test_details`, {
          method: "POST"
        });
        if (!response.ok) {
          throw new Error('Error fetching tests');
        }
        const data = await response.json();
        console.log(data);
        setTests(data || []);
      } catch (err) {
        console.log(err);
      }
    };

    fetchTests();

    // Fetch user data
    fetch('/api/user')  // Replace with your actual API endpoint
      .then(response => response.json())
      .then(data => {
        setUserName(data.user_name); // Set user data
        setExperience(data.experience);
        setLocation(data.location);
        setLoading(false); // Data loaded, stop loading
      })
      .catch(() => {
        setLoading(false); // Stop loading on error
      });
  }, []);

  // Filter tests based on selected category
  const filterTests = tests.filter((test) => {
    if (selectedTestType === "t") {
      return test.test_type === "t"; // Screening Test
    } else if (selectedTestType === "c") {
      return test.test_type === "c"; // Coding Test
    } else if (selectedTestType === "p") {
      return test.test_type === "p" || test.test_type === "a"; // personality Test
    } else if (selectedTestType === "b") {
      return test.test_type === "b" || test.test_type === "a"; // behavioural Test
    }
    return true;
  });

  console.log("Filtered Tests:", filterTests[0]);

  if (loading) {
    return (
      <div className={cn("min-h-screen w-full flex items-center justify-center bg-background")}>
        <div className={cn("w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin")}></div>
      </div>
    );
  }


  // dummy data for testing
  const dummy_tests = [
    {
      company_name: "NewZenAlpha",
      isCompleted: 1,
      scheduled_time: "Fri, 23 May 2025 10:04:00 GMT",
      test_id: "461005",
      test_type: "t",
      topic: "SDE",
    }
  ]


  return (
    <div className={cn("min-h-screen w-full bg-background flex flex-col")}>
      <Navbar />
      <WelcomeSection userName={userName} />
      <div className={cn("w-full bg-[#faf9ff] py-8")}>
        <JobDetails location={location} experience={experience} />
        {/* <TestActions setSelectedTestType={setSelectedTestType} /> */}
        <div className={cn("w-full max-w-7xl mx-auto px-4")}>
          <div className={cn("w-full")}>
            {/* <UpcomingSchedule tests={tests} /> */}
            {/* <TestCard tests={filterTests} setSelectedTestType={setSelectedTestType} /> */}
            <TestCard tests={dummy_tests} setSelectedTestType={setSelectedTestType} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}